// eslint-disable-next-line
import Apis from '@/Apis/_'
import { TipoDocumentoUpload } from '@/types/_'
import { DataTablePagination } from '../interfaces/EmailMensagem'
import ResponseApi from '../interfaces/FactoryResponse'
import { Hemocomponente } from '../interfaces/Solicitacao'

class CoreBase implements ICoreBase {
  async getAllSearch(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllSearch(params)
    return response
  }

  async getSolicitacaoById(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getSolicitacaoByEtapa(params)
    return response
  }

  async backofficeAgendamentoAtualizaSolicitacao(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoAtualizaSolicitacao(params)
    return response
  }

  async backofficeAgendamentoResolvePendenciaDePacienteNoHis(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoResolvePendenciaDePacienteNoHis(params)
    return response
  }

  async bloquearSolicitacao(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.bloquearAgendamento(solicitacaoId)
    return response
  }

  async desbloquearSolicitacao(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.desbloquearAgendamento(solicitacaoId)
    return response
  }

  async getCheckNumeroReserva(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getCheckNumeroReserva(params.solicitacaoId, params.hospitalId, params.numeroReserva)
    return response
  }

  async solicitacaoAuditada(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.solicitacaoAuditada(params)
    return response
  }

  async reservarSala(reserva: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.sendReservaSalas(reserva)
    return response
  }

  async backofficeAgendamentoAlteraReserva(solicitacaoId: string, reserva: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoAlteraReserva(solicitacaoId, reserva)
    return response
  }

  async getReservaHemocomponentes(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllReservaHemocomponentes(solicitacaoId)
    return response
  }

  async deleteLaudo(hospitalId: string, id: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteLaudoById(hospitalId, id)
    return response
  }

  async upload(formData: any, tipoDocumento: TipoDocumentoUpload, headers: any, solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.upload(formData, tipoDocumento, headers, solicitacaoId)
    return response
  }

  async getAllConveniosByUsuarioHospitalLogado(): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllConveniosByUsuarioHospitalLogado()
    return response
  }

  async getAllMedicoByUsuarioId(usuarioId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllMedicoByUsuarioId(usuarioId)
    return response
  }

  async getHospitalCurrentUser(): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getHospitalCurrentUser()
    return response
  }

  async getAllLaudos(solicitacaoId: string, tipoLaudo: TipoDocumentoUpload): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllLaudos(solicitacaoId, tipoLaudo)
    return response
  }

  async getHospitalId(id: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getHospitalById(id)
    return response
  }

  async getHospitalCompletoById(id: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getHospitalCompletoById(id)
    return response
  }

  async postReservaHemocomponentes(hemocomponente: Hemocomponente): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.postReservaHemocomponente(hemocomponente.solicitacaoId, hemocomponente)
    return response
  }

  async postPaciente(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.postPaciente(params)
    return response
  }

  async deleteReservaHemocomponente(tipo: string, solicitacaoId: string): Promise<ResponseApi> {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteReservaHemocomponente(solicitacaoId, tipo)
    return request
  }

  async getAllReservaHemocomponentes(solicitacaoId: string): Promise<ResponseApi> {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllReservaHemocomponentes(solicitacaoId)
    return request
  }

  async getTemplateHospital(hospitalId: string): Promise<ResponseApi> {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getTemplateHospital(hospitalId)
    return request
  }

  async postForncecedor(fornecedor: any): Promise<ResponseApi> {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.postForncecedor(fornecedor)
    return request
  }

  async backofficeVoltaStatus(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeVoltaStatus(params)
    return response
  }

  async backofficeAgendamentoFazCancelamento(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoFazCancelamento(params)
    return response
  }

  async getProcedimentosInternacaoBackofficeSearch(hospitalId: string, searchText: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getProcedimentosInternacaoBackofficeSearch(hospitalId, searchText)
    return response
  }

  async getProcedimentosBackofficeSearch(medicoSolicitanteId: string, hospitalId: string, convenioId: string, searchText: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getProcedimentoSearch(medicoSolicitanteId, hospitalId, convenioId, searchText)
    return response
  }

  async getProcedimentoBackofficeSearch(hospitalId: string, searchText: string, convenioId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getProcedimentoBackofficeSearch(hospitalId, convenioId, searchText)
    return response
  }

  async getProcedimentoPagedSearch(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getProcedimentoPagedSearch(params)
    return response
  }

  async upsertProcedimentoHospital(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.upsertProcedimentoHospital(params)
    return response
  }

  async upsertConvenioHospital(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.upsertConvenioHospital(params)
    return response
  }

  async upsertConvenioPlanoHospital(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.upsertConvenioPlanoHospital(params)
    return response
  }

  async postProcedimentoBackoffice(solicitacaoId: string, procedimento: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.postProcedimentoBackoffice(solicitacaoId, procedimento)
    return response
  }

  async postProcedimentoPrincipal(solicitacaoId: string, procedimento: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.postProcedimento(solicitacaoId, procedimento)
    return response
  }

  async postProcedimento(solicitacaoId: string, procedimento: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.postProcedimento(solicitacaoId, procedimento)
    return response
  }

  async deleteProcedimento(solicitacaoId: string, procedimentoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteProcedimento(solicitacaoId, procedimentoId)
    return response
  }

  async deleteProcedimentoPrincipal(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteProcedimentoPrincipal(solicitacaoId)
    return response
  }

  async deleteProcedimentoBackoffice(solicitacaoId: string, procedimentoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.deleteProcedimentoBackoffice(solicitacaoId, procedimentoId)
    return response
  }

  async getAllFornecedores(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllFornecedores(params)
    return response
  }

  async upsertFornecedor(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.upsertFornecedor(params)
    return response
  }

  async getAllConvenio(id: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllConvenio(id)
    return response
  }

  async getConvenioById(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getConvenioById(params)
    return response
  }

  async getAllPlanos(hospitalId: string, convenioId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllPlanos(hospitalId, convenioId)
    return response
  }

  async getHospitaisByUserCurrent(): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getHospitaisByUserCurrent()
    return response
  }

  async getAllCategoriasByConvenio(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllCategoriasByConvenio(params)
    return response
  }

  async getHospitais(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getHospitais(params.medicoSolicitanteId)
    return response
  }

  async getAllHospital(): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllHospital()
    return response
  }

  async getAllLocalAtendimentoByMedico(medicoId: string, hospotalId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllLocalAtendimentoByMedico(medicoId, hospotalId)
    return response
  }

  async getAllLocalAtendimentoByMedicoId(id: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllLocalAtendimentoByMedicoId(id)
    return response
  }

  async getPessoalAll(dataTableItens: DataTablePagination): Promise<ResponseApi> {
    const response = await Apis.Cadastro.CadastroApi.getPessoalAll(dataTableItens)
    return response
  }

  async getAllPessoaAgendamento(dataTableItens: DataTablePagination): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SuporteApi.getAllPessoaAgendamento(dataTableItens)
    return response
  }

  async getPessoaAgendamentoById(id: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SuporteApi.getPessoaAgendamentoById(id)
    return response
  }

  async getPessoalById(id: string): Promise<ResponseApi> {
    const response = await Apis.Cadastro.CadastroApi.getPessoalById(id)
    return response
  }

  async getUsuarioAgendamentoById(id: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getUsuarioAgendamentoById(id)
    return response
  }

  async pessoaUpsert(params: any): Promise<ResponseApi> {
    const response = await Apis.Cadastro.CadastroApi.pessoaUpsert(params)
    return response
  }

  async usuarioAgendamentoUpsert(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.usuarioAgendamentoUpsert(params)
    return response
  }

  async atualizaPessoaAgendamento(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SuporteApi.atualizaPessoaAgendamento(params)
    return response
  }

  async getCbosAll(): Promise<ResponseApi> {
    const response = await Apis.Cadastro.CadastroApi.getCbosAll()
    return response
  }

  async getPermissoes(): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getPermissoes()
    return response
  }

  async deletePessoa(id: string): Promise<ResponseApi> {
    const response = await Apis.Cadastro.CadastroApi.deletePessoa(id)
    return response
  }

  async updateGrupoOpmeDaSolicitacao(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.updateGrupoOpmeDaSolicitacao(params)
    return response
  }

  async backofficeAgendamentoDesfazCancelamento(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoDesfazCancelamento(params)
    return response
  }

  async getPrecacucoesPacienteFromTasy(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getPrecacucoesPacienteFromTasy(solicitacaoId)
    return response
  }

  async getPowerBiEmbeddedInfo(reportId: string, hospitalId: string): Promise<ResponseApi> {
    const response = await Apis.Cadastro.CadastroApi.getPowerBiEmbeddedInfo(reportId, hospitalId)
    return response
  }

  async getPowerBiReportTypes(): Promise<ResponseApi> {
    const response = await Apis.Cadastro.CadastroApi.getPowerBiReportTypes()
    return response
  }

  async getCentroCirurgico(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getCentroCirurgico(params)
    return response
  }

  async consultaValorNegociadoNoHis(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.consultaValorNegociadoNoHis(params)
    return response
  }

  async getAllCaixasCirurgicas(): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllCaixasCirurgicas()
    return response
  }

  async getAllCaixasCirurgicasByHospitalId(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllCaixasCirurgicasByHospitalId(params)
    return response
  }

  async postCaixaCirurgicaToHospital(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.postCaixaCirurgicaToHospital(params)
    return response
  }

  async putCaixaCirurgicaToHospital(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.putCaixaCirurgicaToHospital(params)
    return response
  }

  async getAllAnestesistas(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllAnestesistas(params)
    return response
  }

  async getAnestesistaById(id: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAnestesistaById(id)
    return response
  }

  async postAnestesista(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.postAnestesista(params)
    return response
  }

  async putAnestesista(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.putAnestesista(params)
    return response
  }

  async getAllAnestesistasByHospitalId(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllAnestesistasByHospitalId(params)
    return response
  }

  async getAnestesistaByHospitalId(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAnestesistaByHospitalId(params)
    return response
  }

  async postAnestesistaToHospital(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.postAnestesistaToHospital(params)
    return response
  }

  async putAnestesistaToHospital(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.putAnestesistaToHospital(params)
    return response
  }

  async resolvePendenciaDeAnestesista(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.resolvePendenciaDeAnestesista(params)
    return response
  }

  async getMedicoByHisId(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getMedicoByHisId(params)
    return response
  }

  async backofficeAgendamentoResolvePendenciaMedico(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoResolvePendenciaMedico(params)
    return response
  }

  async getAllCategoriasByPlano(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllCategoriasByPlano(params)
    return response
  }

  async upsertCategoria(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SuporteApi.upsertCategoria(params)
    return response
  }

  async upsertCategoriaPlano(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SuporteApi.upsertCategoriaPlano(params)
    return response
  }

  async getDoctorSignature(doctorId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getDoctorSignature(doctorId)
    return response
  }
}
interface ICoreBase {
  getAllSearch(params: any): Promise<ResponseApi>
  getSolicitacaoById(solicitacaoId: string): Promise<ResponseApi>
  bloquearSolicitacao(solicitacaoId: string): Promise<ResponseApi>
  desbloquearSolicitacao(solicitacaoId: string): Promise<ResponseApi>
  getCheckNumeroReserva(params: any): Promise<ResponseApi>
  solicitacaoAuditada(params: any): Promise<ResponseApi>
  reservarSala(reserva: any): Promise<ResponseApi>
  backofficeAgendamentoAlteraReserva(solicitacaoId: string, reserva: any): Promise<ResponseApi>
  getReservaHemocomponentes(solicitacaoId: any): Promise<ResponseApi>
  deleteLaudo(hospitalId: string, id: string): Promise<ResponseApi>
  upload(formData: any, tipoDocumento: TipoDocumentoUpload, headers: any, solicitacaoId: string): Promise<ResponseApi>
  getAllConveniosByUsuarioHospitalLogado(): Promise<ResponseApi>
  getAllMedicoByUsuarioId(usuarioId: string): Promise<ResponseApi>
  getHospitalCurrentUser(): Promise<ResponseApi>
  getHospitalId(id: string): Promise<ResponseApi>
  getHospitalCompletoById(id: string): Promise<ResponseApi>
  postReservaHemocomponentes(hemocomponente: Hemocomponente): Promise<ResponseApi>
  deleteReservaHemocomponente(tipo: string, solicitacaoId: string): Promise<ResponseApi>
  getAllReservaHemocomponentes(solicitacaoId: string): Promise<ResponseApi>
  postPaciente(params: any): Promise<ResponseApi>
  getTemplateHospital(hospitalId: String): Promise<ResponseApi>
  postForncecedor(fornecedor: any): Promise<ResponseApi>
  getAllLaudos(solicitacaoId: string, tipoLaudo: TipoDocumentoUpload): Promise<ResponseApi>
  backofficeVoltaStatus(params: any): Promise<ResponseApi>
  backofficeAgendamentoFazCancelamento(params: any): Promise<ResponseApi>
  getProcedimentosInternacaoBackofficeSearch(hospitalId: string, searchText: string): Promise<ResponseApi>
  getProcedimentosBackofficeSearch(medicoSolicitanteId: string, hospitalId: string, convenioId: string, searchText: string): Promise<ResponseApi>
  getProcedimentoBackofficeSearch(hospitalId: string, searchText: string, convenioId: string): Promise<ResponseApi>
  getProcedimentoPagedSearch(params: any): Promise<ResponseApi>
  upsertProcedimentoHospital(params: any): Promise<ResponseApi>
  upsertConvenioHospital(params: any): Promise<ResponseApi>
  upsertConvenioPlanoHospital(params: any): Promise<ResponseApi>
  postProcedimentoBackoffice(solicitacaoId: string, procedimento: any): Promise<ResponseApi>
  postProcedimentoPrincipal(solicitacaoId: string, procedimento: any): Promise<ResponseApi>
  postProcedimento(solicitacaoId: string, procedimento: any): Promise<ResponseApi>
  deleteProcedimento(solicitacaoId: string, procedimentoId: string): Promise<ResponseApi>
  deleteProcedimentoPrincipal(solicitacaoId: string): Promise<ResponseApi>
  deleteProcedimentoBackoffice(solicitacaoId: string, procedimentoId: string): Promise<ResponseApi>
  backofficeAgendamentoAtualizaSolicitacao(params: any): Promise<ResponseApi>
  backofficeAgendamentoResolvePendenciaDePacienteNoHis(params: any): Promise<ResponseApi>
  getAllFornecedores(params: any): Promise<ResponseApi>
  upsertFornecedor(params: any): Promise<ResponseApi>
  getAllConvenio(id: string): Promise<ResponseApi>
  getConvenioById(params: any): Promise<ResponseApi>
  getAllPlanos(hospitalId: string, convenioId: string): Promise<ResponseApi>
  getHospitaisByUserCurrent(): Promise<ResponseApi>
  getAllCategoriasByConvenio(params: any): Promise<ResponseApi>
  getHospitais(params: any): Promise<ResponseApi>
  getAllHospital(): Promise<ResponseApi>
  getAllLocalAtendimentoByMedico(medicoId: string, hospitalId: string): Promise<ResponseApi>
  getAllLocalAtendimentoByMedicoId(id: string): Promise<ResponseApi>
  getPessoalAll(dataTableItens: DataTablePagination): Promise<ResponseApi>
  getAllPessoaAgendamento(dataTableItens: DataTablePagination): Promise<ResponseApi>
  getPessoaAgendamentoById(id: string): Promise<ResponseApi>
  getPessoalById(id: string): Promise<ResponseApi>
  getUsuarioAgendamentoById(id: string): Promise<ResponseApi>
  pessoaUpsert(params: any): Promise<ResponseApi>
  usuarioAgendamentoUpsert(params: any): Promise<ResponseApi>
  atualizaPessoaAgendamento(params: any): Promise<ResponseApi>
  getCbosAll(): Promise<ResponseApi>
  getPermissoes(): Promise<ResponseApi>
  deletePessoa(id: string): Promise<ResponseApi>
  updateGrupoOpmeDaSolicitacao(params: any): Promise<ResponseApi>
  backofficeAgendamentoDesfazCancelamento(params: any): Promise<ResponseApi>
  getPrecacucoesPacienteFromTasy(solicitacaoId: string): Promise<ResponseApi>
  getPowerBiEmbeddedInfo(reportId: string, hospitalId?: string): Promise<ResponseApi>
  getPowerBiReportTypes(): Promise<ResponseApi>
  getCentroCirurgico(params: any): Promise<ResponseApi>
  consultaValorNegociadoNoHis(params: any): Promise<ResponseApi>
  getAllCaixasCirurgicas(): Promise<ResponseApi>
  getAllCaixasCirurgicasByHospitalId(params: any): Promise<ResponseApi>
  postCaixaCirurgicaToHospital(params: any): Promise<ResponseApi>
  putCaixaCirurgicaToHospital(params: any): Promise<ResponseApi>

  getAllAnestesistas(params: any): Promise<ResponseApi>
  getAnestesistaById(id: string): Promise<ResponseApi>
  postAnestesista(params: any): Promise<ResponseApi>
  putAnestesista(params: any): Promise<ResponseApi>

  getAllAnestesistasByHospitalId(params: any): Promise<ResponseApi>
  getAnestesistaByHospitalId(params: any): Promise<ResponseApi>
  postAnestesistaToHospital(params: any): Promise<ResponseApi>
  putAnestesistaToHospital(params: any): Promise<ResponseApi>

  resolvePendenciaDeAnestesista(params: any): Promise<ResponseApi>
  getMedicoByHisId(params: any): Promise<ResponseApi>
  backofficeAgendamentoResolvePendenciaMedico(params: any): Promise<ResponseApi>

  getAllCategoriasByPlano(params: any): Promise<ResponseApi>
  upsertCategoria(params: any): Promise<ResponseApi>
  upsertCategoriaPlano(params: any): Promise<ResponseApi>
  getDoctorSignature(doctorId: string): Promise<ResponseApi>
}

export {
  CoreBase,
  ICoreBase,
}
